<template>
  <div class="mobile-container" ref="container" >
    <Head />
    <Content>
      <Main @focusOut="handleFocusOut" @focusIn="handleFocusIn" />
    </Content>
  </div>
</template>

<script>
import Head from "./components/Head.vue";
import Content from "./components/Content.vue";
import Main from "./components/main.vue";
export default {
  components: {
    Head,
    Content,
    Main,
  },
  data() {
    return {
      defaultHeight: 0,
    };
  },
  mounted() {
    this.defaultHeight = window.innerHeight;
  },
  methods: {
    toVw(number) {
      const radio = this.defaultHeight / 100;
      return (number / radio).toFixed(2) + "%";
    },
    handleFocusOut() {
      setTimeout(() => {
        this.$refs.container.style.height = this.defaultHeight + 'px'
      }, 100);
    },
    handleFocusIn(fn) {
      setTimeout(() => {
        this.$refs.container.style.height = window.innerHeight + 'px'
        window.scrollTo({
          top: 0,
          behavior: "smooth", // 可选，平滑滚动
        });
        this.$nextTick(() => fn && fn())
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.mobile-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: #01172c;
}
</style>
